import { render, staticRenderFns } from "./projectsLog.vue?vue&type=template&id=065f62cf&"
import script from "./projectsLog.vue?vue&type=script&lang=js&"
export * from "./projectsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports